import { Controller } from "@hotwired/stimulus";

// Sélecteur de portée multi-écoles (rôle complexe).
// L'option n'est PROPOSÉE que lorsque l'audience choisie est globale
// (tous les parents / tout le personnel / par rôle) — un ciblage classe/élève
// spécifique à une école n'a pas de sens cross-école.
// Quand elle est active, affiche/masque la liste des écoles selon la portée et
// désactive les champs pour qu'ils ne soient soumis qu'en mode "multi".
export default class extends Controller {
  static targets = ["schools", "input"];
  static values = { global: Array };

  connect() {
    this.onAudienceChange = this.onAudienceChange.bind(this);
    this.audienceRadios().forEach((radio) =>
      radio.addEventListener("change", this.onAudienceChange),
    );
    this.refresh();
  }

  disconnect() {
    this.audienceRadios().forEach((radio) =>
      radio.removeEventListener("change", this.onAudienceChange),
    );
  }

  onAudienceChange() {
    this.refresh();
  }

  toggle() {
    this.refresh();
  }

  refresh() {
    const global = this.isGlobalAudience();
    // L'option multi-écoles n'apparaît que pour les audiences globales.
    this.element.classList.toggle("hidden", !global);
    if (!global) this.forceSingle();

    const multi = global && this.selectedScope() === "multi";
    this.schoolsTarget.classList.toggle("hidden", !multi);
    this.inputTargets.forEach((input) => {
      // L'école courante reste verrouillée ; les autres ne sont actives qu'en multi.
      input.disabled = input.dataset.locked === "true" ? true : !multi;
    });
  }

  forceSingle() {
    const single = this.element.querySelector(
      "input[type=radio][name$='[broadcast_scope]'][value='single']",
    );
    if (single) single.checked = true;
  }

  selectedScope() {
    const checked = this.element.querySelector(
      "input[type=radio][name$='[broadcast_scope]']:checked",
    );
    return checked ? checked.value : "single";
  }

  isGlobalAudience() {
    const form = this.element.closest("form");
    if (!form) return true;
    const checked = form.querySelector("input[name$='[send_to_whom]']:checked");
    if (!checked) return true; // pas encore choisi → on laisse l'option visible
    return this.globalValue.includes(checked.value);
  }

  audienceRadios() {
    const form = this.element.closest("form");
    if (!form) return [];
    return Array.from(
      form.querySelectorAll(
        "input[name$='[send_to_whom]'], input[name$='[audience]']",
      ),
    );
  }
}
